









































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import uuifComponent from '@/shared/uuifComponent';
import { Component, Prop } from 'vue-property-decorator';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { InfoState } from '@/core';

@Component({
  components: {
    ...uuifComponent,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwSelect,
    SwTextarea,
  },
})

export default class DeclineQuoteModal extends SwExtendedVue {
  @Prop()
  isDeclineModal: boolean;
  @Prop()
  quoteId: string;

  cancellationReasonValidation: boolean = false;
  selectCompetitorValidation: boolean = false;
  declineQuoteDescriptionValidation: boolean = false;
  remark: any = '';
  reasonText: any = '';
  errorMsg: any = '';
  reasonOptions: any = [
    {
      id: 0,
      label: this.$t('quote.reasonOptions.opt1')
      .toString(),
      value: 'Select Reason',
    },
    {
      id: 1,
      label: this.$t('quote.reasonOptions.opt2')
      .toString(),
      value: 'Other Support: In-House',
    },
    {
      id: 2,
      label: this.$t('quote.reasonOptions.opt3')
      .toString(),
      value: 'Other Support: Third Party',
    },
    {
      id: 3,
      label: this.$t('quote.reasonOptions.opt4')
      .toString(),
      value: 'Product Replacement Competitor',
    },
    {
      id: 4,
      label: this.$t('quote.reasonOptions.opt4')
      .toString(),
      value: 'Renewing through SonicWall Reseller',
    },
    {
      id: 5,
      label: this.$t('quote.reasonOptions.opt5')
      .toString(),
      value: 'Device is no longer in use',
    },
    {
      id: 6,
      label: this.$t('quote.reasonOptions.opt6')
      .toString(),
      value: 'Switched to another security provider',
    },
    {
      id: 7,
      label: this.$t('quote.reasonOptions.opt7')
      .toString(),
      value: 'Device used for routing purposes only',
    },
    {
      id: 8,
      label: this.$t('quote.reasonOptions.opt6')
      .toString(),
      value: 'Renewal is not within budget',
    }].sort((a, b) => a['label'] > b['label'] ? 1 : a['label'] === b['label'] ? 0 : -1);
  selectedReason: any = 0;
  competitorOptions: any = [
    {
      id: 0,
      label: this.$t('quote.compOptions.opt1')
      .toString(),
      value: 'Select Competitor',
    },
    {
      id: 1,
      label: this.$t('quote.compOptions.opt2')
      .toString(),
      value: 'COMP AVG',
    },
    {
      id: 2,
      label: this.$t('quote.compOptions.opt3')
      .toString(),
      value: 'Clone Error',
    },
    {
      id: 3,
      label: this.$t('quote.compOptions.opt4')
      .toString(),
      value: 'Barracuda',
    },
    {
      id: 4,
      label: this.$t('quote.compOptions.opt5')
      .toString(),
      value: 'Checkpoint',
    },
    {
      id: 5,
      label: this.$t('quote.compOptions.opt6')
      .toString(),
      value: 'Cisco',
    },
    {
      id: 6,
      label: this.$t('quote.compOptions.opt7')
      .toString(),
      value: 'Fortinet',
    },
    {
      id: 7,
      label: this.$t('quote.compOptions.opt8')
      .toString(),
      value: 'Juniper-Netscreen',
    },
    {
      id: 8,
      label: this.$t('quote.compOptions.opt9')
      .toString(),
      value: 'McAfee',
    },
    {
      id: 9,
      label: this.$t('quote.compOptions.opt10')
      .toString(),
      value: 'Microsoft',
    },
    {
      id: 10,
      label: this.$t('quote.compOptions.opt11')
      .toString(),
      value: 'Symantec-Norton',
    },
    {
      id: 11,
      label: this.$t('quote.compOptions.opt12')
      .toString(),
      value: 'Trend Micro',
    },
    {
      id: 12,
      label: this.$t('quote.compOptions.opt13')
      .toString(),
      value: 'Watchguard',
    },
    {
      id: 13,
      label: this.$t('quote.compOptions.opt14')
      .toString(),
      value: 'Websense',
    },
    {
      id: 14,
      label: this.$t('quote.compOptions.opt15')
      .toString(),
      value: 'Viper',
    }].sort((a, b) => a['label'] > b['label'] ? 1 : a['label'] === b['label'] ? 0 : -1);
  selectedCompetitor: any = 0;

  selectReason() {
    this.selectCompetitorValidation = false;
    this.cancellationReasonValidation = false;
    this.declineQuoteDescriptionValidation = false;
  }
  declineQuote() {
    const data = {
      quoteID:this.quoteId,
      remark:this.remark,
      reason: this.reasonText,
      selectedReason: this.reasonOptions.filter((ele:any) => ele.id === this.selectedReason),
      selectedCompetitor: this.competitorOptions.filter((ele:any) => ele.id === this.selectedCompetitor),
    };
    this.selectCompetitorValidation = false;
    this.cancellationReasonValidation = false;
    this.declineQuoteDescriptionValidation = false;
    if (this.selectedReason !== 0) {
      if (this.selectedReason === 3) {
        if (this.selectedCompetitor !== 0) {
          this.remark = `${data.selectedReason[0].value}: ${data.selectedCompetitor[0].value}`;
          this.updateDecline();
        } else {
          this.selectCompetitorValidation = true;
        }
      } else if (this.selectedReason === 1 || this.selectedReason === 2) {
        if (this.reasonText !== '') {
          this.remark = `${data.selectedReason[0].value}: ${this.reasonText}`;
          this.updateDecline();
        } else {
          this.declineQuoteDescriptionValidation = true;
        }
      } else {
        this.remark = data.selectedReason[0].value;
        this.updateDecline();
      }
    } else {
      this.cancellationReasonValidation = true;
    }
  }
  updateDecline() {
    const request = {
      equoteId: this.quoteId,
      remarks: this.remark,
    };
    this.$store
      .dispatch('SnbQuotesStoreModule/declineQuote', request)
      .then((res:any) => {
        this.$store.commit('stopLoading');
        if (res.msgCode === 'MSWAPP:UPDATEQUOTE') {
          const message: InfoState = {
            infoType: 'success',
            infoMsg: res.msgDesc,
          };
          this.$emit('closeModal');
          this.$store.commit('displayMessage', message);
        }
      });
  }
  cancel() {
    this.selectCompetitorValidation = false;
    this.cancellationReasonValidation = false;
    this.declineQuoteDescriptionValidation = false;
    this.selectedCompetitor = 0;
    this.reasonText = '';
    this.selectedReason = 0;
  }
  closeDialog() {
    this.$emit('closeModal');
  }
}
